/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MobileReimbursementResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class MobileReimbursementController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-reimbursement-controller
   * @name GetMobileReimbursementById
   * @request GET:/api/m/reimbursement/{id}
   */
  getMobileReimbursementById = (id: string, params: RequestParams = {}) =>
    this.http.request<MobileReimbursementResponse, any>({
      path: `/m/reimbursement/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMobileReimbursementByIdPath = '/m/reimbursement/${id}'
  static getMobileReimbursementByIdMethod = 'GET'
}
